import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { Suspense, useEffect } from "react";
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import { goToListPageAtom } from "../atoms";
import {
  ModalLoaderQuery,
  PackageType,
} from "./__generated__/ModalLoaderQuery.graphql";

type Props = { type: PackageType };

export const ModalLoader = ({ type }: Props) => {
  const [queryRef, loadQuery] = useQueryLoader<ModalLoaderQuery>(
    ModalLoaderQueryString
  );

  useEffect(() => {
    loadQuery({ packageType: type }, { fetchPolicy: "store-or-network" });
  }, [loadQuery, type]);

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? <ModalLoaderInner queryRef={queryRef} type={type} /> : null}
    </Suspense>
  );
};

type InnerProps = {
  queryRef: PreloadedQuery<ModalLoaderQuery>;
  type: PackageType;
};

const ModalLoaderInner = ({ queryRef, type }: InnerProps) => {
  const data = usePreloadedQuery(ModalLoaderQueryString, queryRef);
  const goToListPage = useSetAtom(goToListPageAtom);

  useEffect(() => {
    if (data) {
      goToListPage({
        customerRef: data.session?.currentClientProfile?.member || null,
        type,
      });
    }
  }, [data, goToListPage, type]);

  return <Loader />;
};

const ModalLoaderQueryString = graphql`
  query ModalLoaderQuery($packageType: PackageType!) {
    session {
      currentClientProfile {
        member {
          ... on Customer {
            ...PackagesList_customer
            allPackages: memberPackages(type: $packageType) {
              count
            }
          }
        }
      }
    }
  }
`;
